<template>
	 <div class="content" v-html="commissionData">
	 </div>
</template>

<script>
	export default{
		data(){
			return{
				commissionData:""
			}
		},
		mounted() {
		  //获取佣金设置
		  this.getAgentCommissionPlan();
		},
		methods:{
			getAgentCommissionPlan() {
			  var _this = this;
			  var url = _this.$api.getAgentCommissionPlan;
			  this.$nkhttp.http(url,'',"get",res=>{
				  _this.commissionData = res.rule;
			  })
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
	.content {
	  padding: 20px;
	  margin: 0 auto;
	  overflow: scroll;
	  width: 90%;
	  height: 90%;
	}
</style>
